export default __webpack_public_path__ + "static/media/image-01.df1d9d84.jpg";